import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const REGEXES = {
    LENGTH: new RegExp(/.{7,}/),
    NUMBER: new RegExp(/(?=.*\d)/),
    LETTER: new RegExp(/^.*(?=.*[a-zA-Z]).*$/)
};

const TESTS = {
    NUMBER: 'number',
    LENGTH: 'length',
    NAME: 'name',
    LETTER: 'letter',
    SECURE: 'secure'
};

export const evaluatePassword = (password, firstName, lastName, isServerValid) => {
    const fullName = (`${firstName}${lastName}`.replace(/\s/g, '')).toLowerCase();
    const nameTest = !((password.toLowerCase()).includes(fullName)
    || fullName.includes(password.toLowerCase()));
    return {
        [TESTS.LENGTH]: REGEXES.LENGTH.test(password),
        [TESTS.LETTER]: REGEXES.LETTER.test(password),
        [TESTS.NAME]: nameTest,
        [TESTS.NUMBER]: REGEXES.NUMBER.test(password),
        [TESTS.SECURE]: isServerValid
    };
};


const PasswordStrength = (props) => {
    const {
        password,
        firstName,
        lastName,
        validations,
        labels,
        expanded,
        setIsValid,
        isServerValid
    } = props;

    const [validationsResults, setValidationsResults] = useState({
        [TESTS.LENGTH]: false,
        [TESTS.LETTER]: false,
        [TESTS.NAME]: false,
        [TESTS.NUMBER]: false,
        [TESTS.SECURE]: false
    });

    const [progress, setProgress] = useState(0);

    const {
        [TESTS.LENGTH]: lengthTest,
        [TESTS.LETTER]: letterTest,
        [TESTS.NAME]: nameTest,
        [TESTS.NUMBER]: numberTest,
        [TESTS.SECURE]: secureTest
    } = validationsResults;

    useEffect(() => {
        setValidationsResults(evaluatePassword(password, firstName, lastName, isServerValid));
    }, [password, firstName, lastName, isServerValid]);

    useEffect(() => {
        setProgress(
            (
                (lengthTest ? 1 : 0)
                + (letterTest ? 1 : 0)
                + (nameTest ? 1 : 0)
                + (numberTest ? 1 : 0)
                + (secureTest ? 1 : 0)
            ) / Object.keys(validationsResults).length * 100
        );
    }, [validationsResults]);
    useEffect(() => {
        setIsValid(progress === 100);
    }, [progress]);
    return (
        <section
            className={cn('password-strength-section', { expanded })}
        >
            <div
                className={cn('progress-bar')}
            >
                <span>
                    { labels.title }
                </span>
                <span>
                    { (
                        lengthTest && letterTest && nameTest && numberTest
                    ) ? labels.strong : labels.weak
                    }
                </span>
                <div
                    className={cn('evaluation')}
                >
                    <span
                        style={{ width: `${progress}%` }}
                    />
                </div>
            </div>
            <div
                className={cn('requirements-list')}
            >
                <span>
                    { labels.requirements }
                </span>
                <ul>
                    {
                        Object.keys(validationsResults).map(key => (
                            <li
                                key={key}
                                className={cn({ passed: validationsResults[key] })}
                            >
                                { validations[key] }
                            </li>
                        ))
                    }
                </ul>
            </div>
        </section>
    );
};

PasswordStrength.propTypes = {
    password: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    validations: PropTypes.shape({
        length: PropTypes.string.isRequired,
        number: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        letter: PropTypes.string.isRequired
    }).isRequired,
    labels: PropTypes.shape({
        title: PropTypes.string.isRequired,
        weak: PropTypes.string.isRequired,
        strong: PropTypes.string.isRequired,
        requirements: PropTypes.string.isRequired
    }).isRequired,
    expanded: PropTypes.bool.isRequired,
    setIsValid: PropTypes.func.isRequired,
    isServerValid: PropTypes.bool.isRequired
};

export default PasswordStrength;
